// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getBlogs } from "@gcg/App/Services/BlogService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";

export interface GetBlogsHandlerParameter {
    category?: string[];
    brand?: string[];
    solution?: string[];
    pageSize?: number;
}

type Parameter = {
    category?: string[];
    brand?: string[];
    solution?: string[];
    pageSize?: number;
    onSuccess?: (success: string) => void;
    onError?: (error: string) => void;
};

type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetBlogsHandlerParameter, ServiceResult<any>>;

export const DispatchBeginLoadBlogs: HandlerType = (props: any) => {
    props.dispatch({
        type: "Blog/BeginLoadBlogs",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = {
        category: props.parameter?.category,
        brand: props.parameter?.brand,
        solution: props.parameter?.solution,
        pageSize: 4,
    };
};

export const GetBlogs: HandlerType = async (props: any) => {
    props.apiResult = await getBlogs(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = (props: any) => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = (props: any) => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const DispatchCompletedLoadBlogs: HandlerType = (props: any) => {
    const blogs = props.apiResult.result.blogs;

    props.dispatch({
        type: "Blog/CompletedLoadBlogs",
        isLoading: false,
        blogs,
        parameter: getDataViewKey(props.apiParameter),
    });
};

export const chain = [
    DispatchBeginLoadBlogs,
    PopulateApiParameter,
    GetBlogs,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompletedLoadBlogs,
];

const loadBlogs = createHandlerChainRunner(chain, "loadBlogs");
export default loadBlogs;
